import {
  Menu,
  MenuItem,
  Avatar,
  Grid,
  IconButton,
  Popover,
  Tooltip,
  Box,
  Divider,
} from "@mui/material";
import React, { useState } from "react";
import { useUsuarioStorage } from "../../../../Storage/UsuariosStorage";
import theme from "../../../../Styles/theme";
import { EditarFotoDePerfilModal } from "../EditarFotoDePerfilModal";
import { ExcluirFotoPerfilModal } from "../ExcluirFotoPerfil";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import { useEntidade } from "../../../../Hooks/EntidadeHook";
import { useUsuario } from "../../../../Hooks/UsuarioHook";

export const UsuarioFoto = () => {
  const { usuario } = useUsuario();
  const { usuarioFocus ,setUsuarioFocus} = useUsuarioStorage();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [alteraFotoModal, setAlteraFotoModal] = useState(false);
  const [excluirFotoModal, setExcluirFotoModal] = useState(false);
  const { entidadeFocus } = useEntidade();

  const handleOpenOptions = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseOptions = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "user-photo-popover" : undefined;

  return (
    <Grid
      item
      xs={12}
      sx={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
        mt: 1,
      }}
    >
      {usuarioFocus?.usuario?.id ? (
        <>
          <Tooltip title="Abrir Opções">
            <IconButton
              onClick={handleOpenOptions}
              sx={{ p: 0, borderRadius: "50%", boxShadow: 1 }}
            >
              <Avatar
                alt="Foto de Perfil"
                src={usuarioFocus?.usuario?.foto || ""}
                sx={{
                  width: 64, // Avatar menor
                  height: 64, // Avatar menor

                  transition: "0.2s",
                  "&:hover": {
                    transform: "scale(1.05)",
                    boxShadow: 3,
                  },
                }}
              />
            </IconButton>
          </Tooltip>

          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleCloseOptions}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
            sx={{ mt: 1 }}
          >
            <Box sx={{ width: "auto", minWidth: 160, p: 1 }}>
              {" "}
              {/* Ajustado tamanho do popover */}
              <MenuItem
                onClick={() => {
                  handleCloseOptions();
                  setAlteraFotoModal(true);
                }}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  whiteSpace: "nowrap",
                }} // Evita corte
              >
                <EditIcon fontSize="small" />
                Editar Foto
              </MenuItem>
              {usuarioFocus?.usuario?.foto && (
                <>
                  <Divider />
                  <MenuItem
                    onClick={() => {
                      handleCloseOptions();
                      window.open(usuarioFocus.usuario.foto, "_blank");
                    }}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      whiteSpace: "nowrap",
                    }} // Evita corte
                  >
                    <VisibilityIcon fontSize="small" />
                    Ver Foto
                  </MenuItem>
                </>
              )}
              {usuarioFocus?.usuario?.foto && (
                <>
                  <Divider />
                  <MenuItem
                    onClick={() => {
                      setExcluirFotoModal(true);
                      handleCloseOptions();
                    }}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      color: theme.colors.attention,
                      whiteSpace: "nowrap",
                    }} // Evita corte
                  >
                    <DeleteIcon fontSize="small" />
                    Excluir Foto
                  </MenuItem>
                </>
              )}
            </Box>
          </Popover>
        </>
      ) : (
        <>
          {!usuario?.usuario?.id && (
            <Box
              sx={{
                width: 80,
                height: 80,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "action.hover",
                borderRadius: "8px",
                boxShadow: 2,
                overflow: "hidden", // Garante que nada fique fora do contêiner
              }}
            >
              <img
                src={entidadeFocus.logo}
                alt="Logo do Município"
                style={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  objectFit: "contain", // Garante que a imagem se ajuste sem cortes
                }}
              />
            </Box>
          )}
        </>
      )}

      <EditarFotoDePerfilModal
        open={alteraFotoModal}
        onClose={() => setAlteraFotoModal(false)}
      />
      <ExcluirFotoPerfilModal
        open={excluirFotoModal}
        onClose={() => setExcluirFotoModal(false)}
      />
    </Grid>
  );
};
